/**
 * Test if a color is to dark or not
 * @param color
 */
export function testDarkColor(color: string) {
  const c = color.substring(1);
  const rgb = parseInt(c, 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;
  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luma < 45;
}

export function generateRandomHEXColor() {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
}
